import React from "react";

// ===================================================================
// The Crowd v2 — Carte de module
//
// Une carte cliquable de l'accueil ou d'une page de regroupement.
// Aucun appel API : la page fournit le contenu et l'action au clic.
//
// Props :
//   titre, description, icone (trace SVG, viewBox 16x16)
//   pied        texte du bas de carte ("3 modules", "Ouvrir"...) — optionnel
//   aCadrer     affiche le badge « À cadrer »
//   taille      "grande" (accueil) ou "normale" (regroupement)
//   onClick
// ===================================================================

function CarteModule({ titre, description, icone, pied, aCadrer = false, taille = "normale", onClick }) {
  return (
    <button
      type="button"
      className={`v2-carte v2-carte-${taille}${aCadrer ? " v2-carte-a-cadrer" : ""}`}
      onClick={onClick}
    >
      <span className="v2-carte-haut">
        <span className="v2-carte-icone" aria-hidden="true">
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d={icone} />
          </svg>
        </span>
        <span className="v2-carte-texte">
          <span className="v2-carte-titre">
            {titre}
            {aCadrer && <span className="v2-badge">À cadrer</span>}
          </span>
          <span className="v2-carte-desc">{description}</span>
        </span>
      </span>

      {pied && (
        <span className="v2-carte-pied">
          <span>{pied}</span>
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M3 8h9M8.5 4.5 12 8l-3.5 3.5" />
          </svg>
        </span>
      )}
    </button>
  );
}

export default CarteModule;
